import { useState } from "react";
import type { ChangeEvent } from "react";

import { Form, Header } from "simplydo/react/ui";
import { Input } from "simplydo/react/ui";

import util from "utils/utils";

import { FieldProps, getAssessmentFieldOptions } from "./FieldProps";

const Assessment = ({
  field,
  fieldValue,
  isEditing,
  updateIdea,
  assessmentIsClosed,
}: FieldProps) => {
  const assessmentOptions = getAssessmentFieldOptions(field.options);
  const availableScore = assessmentOptions.availableScore ?? 0;
  const scoreValue =
    typeof fieldValue === "number" || typeof fieldValue === "string" ?
      fieldValue
    : "";
  const [score, setScore] = useState<number | string>(scoreValue);

  if (!isEditing) {
    return (
      <div>
        <Header size="tiny">Score</Header>
        {scoreValue} / {availableScore}
      </div>
    );
  }

  return (
    <Form>
      <Form.Field
        control={Input}
        width="8"
        disabled={!isEditing || assessmentIsClosed}
        label={`Score (between 0 - ${availableScore})`}
        value={score ?? ""}
        placeholder="Enter a score..."
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          util.limitNumberInput(e, (val) => {
            const newScore =
              val === "" ? val : (
                Math.max(0, Math.min(availableScore, Number(val)))
              );
            updateIdea(newScore, ["assessment", field.id, "score"]);
            setScore(newScore);
          })
        }
        type="number"
        min="0"
        max={String(availableScore)}
      />
    </Form>
  );
};

export default Assessment;
